// src/contexts/AuthProvider.js
import axios from 'axios';
import { createContext, useContext, useMemo } from 'react';

// Create the Auth context
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Create a stable Axios instance that automatically sends cookies

  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: '',
      withCredentials: true,
    });

    
  // Optional global response interceptor for auth errors
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          // Backend indicates the user is not authenticated
          // Individual components/contexts can react accordingly
        }
        return Promise.reject(error);
      },
    );

    return instance;
  }, []);

  const value = { api };


  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext in components
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthProvider;
